import useSocketReconnect from '../../utils/useSocketReconnect';
import { useState } from "react"
import { useEffect } from "react"
import Select from 'react-select';
import { fetchAPI, postAPI } from "../../utils/utils";

function invertDictionary(dict) {
    let inverted = {};
    for (let key in dict) {
        dict[key].forEach((item) => {
            if (item in inverted) {
                inverted[item].push(key);
            } else {
                inverted[item] = [key];
            }
        });
    }
    return inverted;
}

function LastHourNotifications({ socket, tecnica_names, user_names, castellersInfo }) {
    useSocketReconnect(socket, () => {
        socket.emit('.request_responsables');
        socket.emit('.request_responsables_etiquetes');
        socket.emit('.request_responsables_grups');
    });

    const [responsables, setResponsables] = useState({})
    const [responsablesEtiquetes, setResponsablesEtiquetes] = useState({})
    const [responsablesGrups, setResponsablesGrups] = useState({}) // { tecnica_id: [grup_names] }
    const [lastHours, setLastHours] = useState(4)
    const [grups, setGrups] = useState([])
    const [etiquetes, setEtiquetes] = useState([])
    const [etiquetaUsers, setEtiquetaUsers] = useState({}) // { etiqueta_id: [user_ids] }
    const invertedResponsables = invertDictionary(responsables)

    // Calcular grupUsers dels grups carregats
    const grupUsers = grups.reduce((acc, grup) => {
        acc[grup.name] = grup.ids || []
        return acc
    }, {})

    const [isEditing, setIsEditing] = useState(false)
    const [editedHours, setEditedHours] = useState(lastHours)

    const handleHoursChange = async (hours) => {
        if (hours < 1) return;
        postAPI('/edit_last_hours', { hours: parseInt(hours) }, () => {
            setLastHours(hours);
        });
    }

    useEffect(() => {
        fetchAPI('/last_hours', (data) => {
            setLastHours(data.hours);
        });
    }, []);

    useEffect(() => {
        fetchAPI('/notification_groups', (data) => {
            setGrups(data);
        });
    }, []);

    useEffect(() => {
        fetchAPI('/etiquetes', (data) => {
            setEtiquetes(data);
            // Carregar usuaris de cada etiqueta
            data.forEach(etiqueta => {
                fetchAPI(`/etiqueta_users/${etiqueta.id}`, (users) => {
                    setEtiquetaUsers(prev => ({
                        ...prev,
                        [etiqueta.id]: users.map(u => u.id)
                    }));
                });
            });
        });
    }, []);

    useEffect(() => {
        socket.emit(".request_responsables")
        socket.emit(".request_responsables_etiquetes")
        socket.emit(".request_responsables_grups")

        const onResponsables = (data) => {
            setResponsables(data)
        }
        socket.on(".responsables", onResponsables)

        const onResponsablesEtiquetes = (data) => {
            setResponsablesEtiquetes(data)
        }
        socket.on(".responsables_etiquetes", onResponsablesEtiquetes)

        const onResponsablesGrups = (data) => {
            setResponsablesGrups(data)
        }
        socket.on(".responsables_grups", onResponsablesGrups)

        return () => {
            socket.off(".responsables", onResponsables)
            socket.off(".responsables_etiquetes", onResponsablesEtiquetes)
            socket.off(".responsables_grups", onResponsablesGrups)
        }
    }, [])

    const handleChange = (list, action, responsable) => {
        if (action.action === "select-option") {
            socket.emit(".add_responsable", {
                tecnica: responsable,
                user: action.option.value
            })
        } else if (action.action === "remove-value") {
            socket.emit(".remove_responsable", {
                tecnica: responsable,
                user: action.removedValue.value
            })
        } else if (action.action === "clear") {
            socket.emit(".clear_responsables", {
                tecnica: responsable,
            })
        }
    }

    const posahiTothom = (tecnica) => {
        const users = user_names.map((user) => user.value)

        socket.emit(".add_responsables", {
            tecnica: tecnica,
            users: users
        })
    }

    const etiquetaOptions = etiquetes.map(etiqueta => ({
        value: etiqueta.id,
        label: etiqueta.nom
    }))

    const handleEtiquetaChange = (list, action, tecnica) => {
        if (action.action === "select-option") {
            socket.emit(".add_responsable_etiqueta", {
                tecnica: tecnica,
                etiqueta: action.option.value
            })
        } else if (action.action === "remove-value") {
            socket.emit(".remove_responsable_etiqueta", {
                tecnica: tecnica,
                etiqueta: action.removedValue.value
            })
        } else if (action.action === "clear") {
            // Remove all etiquetes for this tecnica
            const currentEtiquetes = responsablesEtiquetes[tecnica] || []
            currentEtiquetes.forEach(etiquetaId => {
                socket.emit(".remove_responsable_etiqueta", {
                    tecnica: tecnica,
                    etiqueta: etiquetaId
                })
            })
        }
    }

    const handleGrupChange = (list, action, tecnica) => {
        if (action.action === "select-option") {
            socket.emit(".add_responsable_grup", {
                tecnica: tecnica,
                grup: action.option.value
            })
        } else if (action.action === "remove-value") {
            socket.emit(".remove_responsable_grup", {
                tecnica: tecnica,
                grup: action.removedValue.value
            })
        } else if (action.action === "clear") {
            // Remove all grups for this tecnica
            const currentGrups = responsablesGrups[tecnica] || []
            currentGrups.forEach(grupName => {
                socket.emit(".remove_responsable_grup", {
                    tecnica: tecnica,
                    grup: grupName
                })
            })
        }
    }

    // Opcions per al selector de grups vinculats
    const grupVinculatOptions = grups.map(grup => ({
        value: grup.name,
        label: grup.name
    }))

    const tecnicaWithResponsables = [
        ...tecnica_names,
        ...Object.keys(responsables)
            .map(tecnica_user_id => {
                const user = castellersInfo[tecnica_user_id]
                if (!user) return null;
                return {
                    value: tecnica_user_id,
                    label: user.nom,
                    color: 'black'
                }
            })
            .filter(item => item !== null)
    ].filter((value, index, self) => 
        index === self.findIndex((t) => (
            parseInt(t.value) === parseInt(value.value)
        ))
    );

    console.log(
        tecnicaWithResponsables
    )

    return (
        <div>
            <div style={{ marginBottom: 20, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h3 style={{ textAlign: 'left' }}>Activar les notificacions</h3>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {isEditing ? (
                        <>
                            <input 
                                type="number" 
                                value={editedHours}
                                onWheel={(event) => event.currentTarget.blur()}
                                onChange={(e) => setEditedHours(e.target.value)}
                                min="1"
                                style={{ 
                                    width: 100,
                                    padding: '5px',
                                    fontSize: '14px',
                                    borderRadius: '4px',
                                    border: '1px solid #ccc',
                                    marginRight: '10px'
                                }}
                            />
                            <button
                                onClick={() => {
                                    handleHoursChange(editedHours);
                                    setIsEditing(false);
                                }}
                                style={{
                                    padding: '5px 10px',
                                    marginRight: '5px',
                                    backgroundColor: '#4CAF50',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer'
                                }}
                            >
                                Desar
                            </button>
                            <button
                                onClick={() => {
                                    setEditedHours(lastHours);
                                    setIsEditing(false);
                                }}
                                style={{
                                    padding: '5px 10px',
                                    backgroundColor: '#f44336',
                                    color: 'white', 
                                    border: 'none',
                                    borderRadius: '4px',
                                    cursor: 'pointer'
                                }}
                            >
                                Cancel·lar
                            </button>
                        </>
                    ) : (
                        <>
                            <span style={{ marginRight: '10px', fontSize: '14px' }}>
                                {lastHours} hores
                            </span>
                            <button
                                onClick={() => {
                                    setEditedHours(lastHours);
                                    setIsEditing(true);
                                }}
                                style={{
                                    padding: '5px 10px',
                                    backgroundColor: '#2196F3',
                                    color: 'white',
                                    border: 'none', 
                                    borderRadius: '4px',
                                    cursor: 'pointer'
                                }}
                            >
                                Editar
                            </button>
                        </>
                    )}
                </div>
                <h3 style={{ textAlign: 'right' }}>abans de l'assaig</h3>
            </div>

            <div style={{ marginBottom: 20 }}>
                <h3>Gent que falta</h3>
                <div style={{ overflow: 'auto', height: 300, display: 'flex', flexWrap: 'wrap', alignContent: 'flex-start' }}>
                    {
                        user_names
                            .sort((a, b) => a.label.localeCompare(b.label))
                            .filter((user) => !(user.value in invertedResponsables) || invertedResponsables[user.value].length === 0)
                            .map((user) => <div style={{ margin: 2, padding: 5, backgroundColor: '#eee', borderRadius: 5 }} key={user.value}>{user.label}</div>)    
                    }
                </div>
            </div>

            {tecnicaWithResponsables.map(name => {
                const usersOfResponsable = (responsables[name.value] || [])
                    .map((user) => user_names.find((u) => parseInt(u.value) === parseInt(user)))

                // Obtenir usuaris de les etiquetes assignades a aquest tècnic
                const etiquetesAssignades = responsablesEtiquetes[name.value] || []
                const directUserIds = (responsables[name.value] || []).map(id => parseInt(id))

                // Usuaris que venen de les etiquetes (amb marca per mostrar-los diferent)
                const usersFromEtiquetes = etiquetesAssignades
                    .flatMap(etiquetaId => {
                        const etiquetaInfo = etiquetes.find(e => e.id === etiquetaId)
                        return (etiquetaUsers[etiquetaId] || [])
                            .filter(userId => !directUserIds.includes(parseInt(userId)))
                            .map(userId => {
                                const userInfo = user_names.find(u => parseInt(u.value) === parseInt(userId))
                                if (!userInfo) return null
                                return {
                                    ...userInfo,
                                    isFromEtiqueta: true,
                                    etiquetaNom: etiquetaInfo?.nom || 'Desconeguda',
                                    isFixed: true
                                }
                            })
                            .filter(Boolean)
                    })

                // Eliminar duplicats d'etiquetes
                const uniqueUsersFromEtiquetes = usersFromEtiquetes.filter((user, index, self) =>
                    index === self.findIndex(u => u.value === user.value)
                )

                // Obtenir usuaris dels grups assignats a aquest tècnic
                const grupsAssignats = responsablesGrups[name.value] || []
                const etiquetaUserIds = uniqueUsersFromEtiquetes.map(u => parseInt(u.value))

                // Usuaris que venen dels grups (amb marca per mostrar-los diferent)
                const usersFromGrups = grupsAssignats
                    .flatMap(grupName => {
                        return (grupUsers[grupName] || [])
                            .filter(userId => !directUserIds.includes(parseInt(userId)))
                            .filter(userId => !etiquetaUserIds.includes(parseInt(userId)))
                            .map(userId => {
                                const userInfo = user_names.find(u => parseInt(u.value) === parseInt(userId))
                                if (!userInfo) return null
                                return {
                                    ...userInfo,
                                    isFromGrup: true,
                                    grupNom: grupName,
                                    isFixed: true
                                }
                            })
                            .filter(Boolean)
                    })

                // Eliminar duplicats de grups
                const uniqueUsersFromGrups = usersFromGrups.filter((user, index, self) =>
                    index === self.findIndex(u => u.value === user.value)
                )

                // Combinar usuaris directes + usuaris d'etiquetes + usuaris de grups
                const allSelectedUsers = [
                    ...usersOfResponsable.filter(Boolean),
                    ...uniqueUsersFromEtiquetes,
                    ...uniqueUsersFromGrups
                ]

                const isResponsableTecnica = castellersInfo[name.value]?.es_tecnica > 0

                return (<div style={{ marginBottom: 25 }} key={name.value}>
                    <div
                        style={{
                            display: 'flex',
                            marginBottom: 10,
                            flexWrap: 'wrap',
                            gap: 5,
                        }}
                    >
                        <div
                            style={{
                                flex: 2,
                                fontSize: 18,
                                fontWeight: "bold",
                                minWidth: 150,
                                display: 'flex',
                                alignItems: 'center',
                            }}
                        >
                            {!isResponsableTecnica ? '⚠️ ' : ''} {name.label}
                        </div>
                        <div
                            style={{
                                border: "1px solid #ccc",
                                color: "#ccc",
                                borderRadius: "4px",
                                textAlign: "center",
                                padding: "0 10px",
                                fontSize: 12,
                                cursor: 'pointer',
                                height: 32,
                                display: 'flex',
                                alignItems: 'center',
                            }}
                            onClick={() => posahiTothom(name.value)}
                        >
                            Posa-hi tothom
                        </div>
                    </div>
                    <Select
                        options={etiquetaOptions}
                        isMulti
                        isClearable
                        placeholder="Etiquetes..."
                        noOptionsMessage={() => "No hi ha etiquetes"}
                        value={(responsablesEtiquetes[name.value] || [])
                            .map(etiquetaId => etiquetaOptions.find(e => e.value === etiquetaId))
                            .filter(Boolean)
                        }
                        onChange={(list, action) => handleEtiquetaChange(list, action, name.value)}
                        styles={{
                            control: (base) => ({ ...base, minHeight: 32, fontSize: 12, marginBottom: 8 }),
                            valueContainer: (base) => ({ ...base, padding: '0 6px' }),
                            input: (base) => ({ ...base, margin: 0, padding: 0 }),
                            indicatorsContainer: (base) => ({ ...base, height: 30 }),
                            multiValue: (base) => ({ ...base, backgroundColor: '#f0e6ff' }),
                            multiValueLabel: (base) => ({ ...base, color: '#6b21a8' }),
                        }}
                    />
                    <Select
                        options={grupVinculatOptions}
                        isMulti
                        isClearable
                        placeholder="Grups vinculats..."
                        noOptionsMessage={() => "No hi ha grups"}
                        value={(responsablesGrups[name.value] || [])
                            .map(grupName => grupVinculatOptions.find(g => g.value === grupName))
                            .filter(Boolean)
                        }
                        onChange={(list, action) => handleGrupChange(list, action, name.value)}
                        styles={{
                            control: (base) => ({ ...base, minHeight: 32, fontSize: 12, marginBottom: 8 }),
                            valueContainer: (base) => ({ ...base, padding: '0 6px' }),
                            input: (base) => ({ ...base, margin: 0, padding: 0 }),
                            indicatorsContainer: (base) => ({ ...base, height: 30 }),
                            multiValue: (base) => ({ ...base, backgroundColor: '#e6fff0' }),
                            multiValueLabel: (base) => ({ ...base, color: '#166534' }),
                        }}
                    />
                    <Select
                        options={user_names}
                        isMulti
                        isClearable
                        name="users"
                        value={allSelectedUsers}
                        onChange={(list, action) => handleChange(list, action, name.value)}
                        placeholder="Castellers particulars..."
                        styles={{
                            valueContainer: (base) => ({ ...base, maxHeight: 150, overflowY: 'auto' }),
                            multiValue: (base, { data }) => {
                                const bgColor = data.isFromEtiqueta ? '#f0e6ff' : data.isFromGrup ? '#e6fff0' : '#dbeafe'
                                return { ...base, backgroundColor: bgColor }
                            },
                            multiValueLabel: (base, { data }) => {
                                const textColor = data.isFromEtiqueta ? '#6b21a8' : data.isFromGrup ? '#166534' : '#1e40af'
                                return { ...base, color: textColor }
                            },
                            multiValueRemove: (base, { data }) => ({
                                ...base,
                                display: data.isFixed ? 'none' : base.display,
                            }),
                        }}
                    />
                </div>)
            })}
        </div>
    )
}

export default LastHourNotifications;